import { formService } from '@common';
import { FertilizerCompositionValidator } from '../modules/fertilizer/validators/fertilizer-composition.validatior';
import { FertilizerNameValidator } from '../modules/fertilizer/validators/fertilizer-name.validatior';
import { LayerGroupKindChangePlugin } from '../modules/geo-layers-upload/plugins/layer-group-kind-change.plugin';
import { AttributesFormGroupChangePlugin } from '../modules/geo-layers-upload/plugins/attributes-form-group-change.plugin';
import { FilterFormChangePlugin } from '../modules/monitoring/plugins/filter-form-change.plugin';
import { PesticideNameValidator } from '../modules/pesticide/validators/pesticide-name.validatior';
import { OnlyOneRequiredValidator } from '../modules/geo-layers-upload/validators/only-one-required.validator';
import { YieldZoneLevelValidator } from '../modules/statistics/validators/yield-zone-level.validatior';
import { SourceYearValidator } from '../modules/statistics/validators/source-year.validatior';
import { UpkeepCostHintChangePlugin } from '../modules/decision-support/plugins/upkeep-cost-hint-change.plugin';
import { HeightmapDataPeriodDateValidator } from '../modules/heightmap/validators/heightmap-data-period-date.validator';
import { SoilTemperaturePeriodDateValidator } from '../modules/statistics/validators/soil-temperature-period-date.validator';

export const registerValidators = () => {
  formService.registerValidator('fertilizerComposition', FertilizerCompositionValidator);
  formService.registerValidator('fertilizerName', FertilizerNameValidator);
  formService.registerValidator('pesticideName', PesticideNameValidator);
  formService.registerValidator('onlyOneRequired', OnlyOneRequiredValidator);
  formService.registerValidator('yieldZoneLevel', YieldZoneLevelValidator);
  formService.registerValidator('sourceYear', SourceYearValidator);
  formService.registerValidator('heightmapDataPeriodDate', HeightmapDataPeriodDateValidator);
  formService.registerValidator('soilTemperaturePeriodDate', SoilTemperaturePeriodDateValidator);
};

export const registerPlugins = () => {
  formService.registerPlugin('layerGroupKindChange', LayerGroupKindChangePlugin);
  formService.registerPlugin('attributesFormGroupChange', AttributesFormGroupChangePlugin);
  formService.registerPlugin('filterFormChange', FilterFormChangePlugin);
  formService.registerPlugin('upkeepCostHintChange', UpkeepCostHintChangePlugin);
};

export const initForms = () => {
  registerValidators();
  registerPlugins();
};
